const checklogin = (state = null, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                text: action.text,
                isauth: true
            }
        case 'LOGOUT':
            // console.log(state)
            console.log(action)

            return {
                ...state
            };
        default:
            return state;
    }
};


export default checklogin;